import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function GoogleCallback() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { login } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token  = params.get('token');
    const dest   = params.get('dest') || '/onboarding';

    if (token) {
      login(token);
      navigate(dest, { replace: true });
    } else {
      navigate('/login?error=google', { replace: true });
    }
  }, []);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <p style={{ color: '#7A90B8', fontFamily: 'Sora, sans-serif' }}>
        Signing you in with Google...
      </p>
    </div>
  );
}
